import React from 'react';
import { useSwiper } from '../hooks/useSwiper';
import TeamCard from './TeamCard';
import { useTranslation } from 'react-i18next';

const TeamSecOne = ({ className }) => {
  const swiperRef = useSwiper('#teamSlider1');
  const { t } = useTranslation();

  return (
    <section className={className} id="team-sec">
      <div className="shape-mockup bg-gradient-shape1 team-bg-gradient1" data-top="-5%" data-left={0} />
      <div className="shape-mockup bg-gradient-shape1 team-bg-gradient2" data-top="20%" data-right="-3%" data-left="auto" />
      
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-xl-7">
            <div className="title-area">
              <span className="sub-title" data-cue="slideInUp">{t('sections.teamSecOne.sub_title','Our Expert Team')}</span>
              <h2 className="sec-title" data-cue="slideInUp">{t('sections.teamSecOne.title','Our Cybersecurity Experts')}</h2>
            </div>
          </div>
          <div className="col-auto">
            <div className="sec-btn" data-cue="slideInUp" data-delay={100}>
              <button className="slider-arrow slider-prev default" data-slider-prev="#teamSlider1">
                <i className="far fa-angle-left" />
              </button>
              <button className="slider-arrow slider-next default" data-slider-next="#teamSlider1">
                <i className="far fa-angle-right" />
              </button>
            </div>
          </div>
        </div>
        
        <div
          ref={swiperRef}
          className="swiper ot-react-slider has-shadow"
          data-cue="slideInUp"
          id="teamSlider1"
          data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"4"}}}'
        >
          <div className="swiper-wrapper">
            <TeamCard className="swiper-slide" limit={8} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSecOne;